import {AuthService} from './auth.service';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {

  URL: string;
  userRole: any;

  constructor(
    private http: HttpClient,
    private auth: AuthService
  ) {
    this.URL = `${environment.baseServerURL}/administration/company`;
    this.userRole = this.auth.user.role;
  }

  buildURL(subPath: string) {
    return `${this.URL}/${subPath}`;
  }

  getCompanyList(): Observable<any> {
    if (this.userRole && this.userRole.name === 'superadmin') {

      return this.http.get(this.buildURL(''), {
          withCredentials: true
        }).pipe(map(result => {
          return result;
        }),
        catchError((err, caught) => {
          console.error(err);
          return new Observable((observer) => {
            observer.next([]);
            observer.complete();
          });
        }));

    } else {
      return new Observable((observer) => {
        observer.next([]);
        observer.complete();
      });
    }

  }

  getCompany(id): Observable<any> {
    return this.http.get(this.buildURL(id), {
      withCredentials: true
    });
  }

  createCompany(company): Observable<any> {
    return this.http.post(this.buildURL(''), company, {
      withCredentials: true
    });
  }

  updateCompany(company): Observable<any> {
    return this.http.put(this.buildURL(company.id), company, {
      withCredentials: true
    });
  }

  deleteCompany(id): Observable<any> {
    return this.http.delete(this.buildURL(id), {
      withCredentials: true
    });
  }

  setupCompany(data): Observable<any> {
    const uploadData = new FormData();
    uploadData.append('file', data.xlsFile);
    uploadData.append('data', JSON.stringify(data));
    return this.http.post(this.buildURL(`${this.auth.user.company}/setup`), uploadData, {
      withCredentials: true
    });
  }
}
